import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  NgModule,
  OnDestroy,
} from "@angular/core";
import { NgControl } from "@angular/forms";
import { Subject } from "rxjs";

@Directive({
  selector: "[appDecimalNumber]",
})
export class DecimalNumberDirective implements OnDestroy{
  @Input("appDecimalNumber") decimalPlaces: number;
  private destroy$ = new Subject<void>();
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener("input", ["$event"]) onEvent() {
    const value = this.el.nativeElement.value;
    if (
      !isNaN(value) &&
      (value.split(".")[1] || []).length > this.decimalPlaces
    ) {
      const valueToTransform = Number(value).toFixed(this.decimalPlaces);
      this.control.control.setValue(valueToTransform);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

@NgModule({
  declarations: [DecimalNumberDirective],
  exports: [DecimalNumberDirective],
})
export class DecimalNumberDirectiveModule {}
